import { render, staticRenderFns } from "./TabUpdatePlateAndStatusSpecimen.vue?vue&type=template&id=712d12a7&scoped=true"
import script from "./TabUpdatePlateAndStatusSpecimen.vue?vue&type=script&lang=js"
export * from "./TabUpdatePlateAndStatusSpecimen.vue?vue&type=script&lang=js"
import style0 from "./TabUpdatePlateAndStatusSpecimen.vue?vue&type=style&index=0&id=712d12a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d12a7",
  null
  
)

export default component.exports